import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";

const BOOKS = [
  { title: "The Wolfkeeper Method", author: "Founder Edition", format: "Hardcover", price: "$48", image: "https://images.unsplash.com/photo-1553882809-a4f57e59501d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxnZXJtYW4lMjBzaGVwaGVyZCUyMGRvZyUyMHBvcnRyYWl0JTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85" },
  { title: "Reading Dogs", author: "Marcus Reyes", format: "Hardcover", price: "$42", image: "https://images.unsplash.com/photo-1622507141724-8ead15590e3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxnZXJtYW4lMjBzaGVwaGVyZCUyMGRvZyUyMHBvcnRyYWl0JTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85" },
  { title: "The Working Bond (Audiobook)", author: "Sofia Delgado", format: "Audio · 8 hrs", price: "$28", image: "https://images.unsplash.com/photo-1683536816438-564ce7de3161?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwZXJzb24lMjB0cmFpbmluZyUyMHdvcmtpbmclMjBkb2clMjBvdXRkb29ycyUyMG5hdHVyZXxlbnwwfHx8fDE3ODU4MTczNjV8MA&ixlib=rb-4.1.0&q=85" },
  { title: "Puppy · A Children's Book", author: "Ana Torres", format: "Illustrated", price: "$22", image: "https://images.unsplash.com/photo-1602241628512-459cdd3234fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHx0aGVyYXB5JTIwc2VydmljZSUyMGRvZyUyMGdvbGRlbiUyMHJldHJpZXZlciUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NTgxNzM2NXww&ixlib=rb-4.1.0&q=85" },
];

export default function Bookstore() {
  return (
    <>
      <Section testid="books-hero" className="pt-40 pb-16">
        <Container>
          <Eyebrow>The Wolfkeeper Bookstore</Eyebrow>
          <DisplayH1 className="mt-6 max-w-4xl">A library of the field.</DisplayH1>
        </Container>
      </Section>
      <Section testid="books-grid" className="pb-32">
        <Container>
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
            {BOOKS.map((b) => (
              <div key={b.title} className="card-lux overflow-hidden group">
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={b.image} alt="" className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" />
                  <div className="absolute inset-0 cinema-overlay" />
                </div>
                <div className="p-6">
                  <div className="overline text-[10px]">{b.format}</div>
                  <div className="mt-2 font-serif-display text-xl">{b.title}</div>
                  <div className="text-sm text-[color:var(--wk-bone-dim)]">{b.author}</div>
                  <div className="text-[color:var(--wk-gold)] mt-3">{b.price}</div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Section>
    </>
  );
}
